import React, { useEffect, useState } from 'react'
import { SubsWrapper } from './styles'

const PlayerWrapper = ({
  children,
  areControlsVisible,
  playerRef
}) => {

  const [subsPosition, setSubsPosition] = useState(0);

  useEffect(() => {
    if (!playerRef.current?.videoHeight) return

    const { videoHeight, videoWidth } = playerRef.current
    const ratioVideo = videoWidth / videoHeight

    const handleResize = () => {
      const ratioScreen = window.innerWidth / window.innerHeight

      if (ratioVideo > ratioScreen) {
        const videoRenderHeight = window.innerWidth / ratioVideo;

        const porcion = (window.innerHeight - videoRenderHeight) / 2
        const pos = (porcion - 110 > 30) ? porcion - 110 : 30

        const newPos = areControlsVisible && pos < 95 ? 100 : pos
        setSubsPosition(newPos)

      } else {
        setSubsPosition(areControlsVisible ? 100 : 30)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)

  }, [window.innerWidth, areControlsVisible]);


  return (
    <SubsWrapper $subsPosition={subsPosition}>
      {children}
    </SubsWrapper>
  )
}


const Tracks = ({ subtitles, currentSubtitle }) => {
  return (
    <>
      {subtitles.map(sub => (
          <track
            key={sub.id || sub.label}
            label={sub.label}
            kind={sub.kind}
            srcLang={sub.srcLang}
            src={sub.src}
            default={sub.srcLang === currentSubtitle}
          />
        ))}
    </>
  )
}

const Subtitles = { Tracks, PlayerWrapper }

export default Subtitles